import { useEffect } from 'react';
import { applySeo, removeJsonLd } from '../utils/seo';

/**
 * React hook wrapper for SEO updates.
 * Applies SEO on mount/update and removes any JSON-LD scripts it created on unmount.
 */
export default function useSeo(config) {
  useEffect(() => {
    const ids = applySeo(config);
    return () => {
      ids.forEach(removeJsonLd);
    };
    // Intentionally re-apply when config changes.
  }, [config]);
}

